import { render, staticRenderFns } from "./client-space-logo.vue?vue&type=template&id=17d25b92&scoped=true"
import script from "./client-space-logo.vue?vue&type=script&lang=js"
export * from "./client-space-logo.vue?vue&type=script&lang=js"
import style0 from "./client-space-logo.vue?vue&type=style&index=0&id=17d25b92&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d25b92",
  null
  
)

export default component.exports